<template>
  <v-dialog id="dlg_configVG" :value="value" @input="$emit('input', $event)" fullscreen hide-overlay transition="dialog-bottom-transition" >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Configuración del Proceso</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <div ref="lbl_configVG_TituloProceso" class="text-h6 font-weight-bold mb-2 text-center">
          {{ tituloProceso }}
        </div>
        <div id="config_FD">
          <FormularioDinamico
            id="Form_configVG_Proceso" 
            :key="nKeyFD"
            :idFormulario="nIdFormulario" 
            :showButtons="false" 
            :initialFormFields="cmp_oInitialFormFields"
          >
            <template #Botones="{ formData, isValid, prepareData, processing, oLocation }">
              <v-row no-gutters justify="center" align="center" class="mb-10 mt-n8">
                <v-col cols="10" class="text-center ma-1">
                  <v-btn :id="`btn_configVG_okSlot`" @click="procesar(formData, isValid, prepareData,oLocation)" large block dark color="btncolor" class="btn-primary btn-rounded" :loading="processing">
                    Almacenar <v-icon size="20" right>mdi-cogs</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="10" class="text-center ma-1" >
                  <v-btn id="btn_configVG_CancelarSlot" @click="$emit('input', false)" large block dark color="error" class="btn-primary btn-rounded">
                    Cancelar <v-icon size="20" right>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </FormularioDinamico>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FormularioDinamico from '@/components/dinamicos/FormularioDinamico.vue';
import { mapGetters } from 'vuex/dist/vuex.common.js';

export default {
  name:'ConfigGV_Proceso',
  components: {
    FormularioDinamico,
  },  
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tituloProceso : {
      required: true,
      type: String,
      default: ''
    },
    nIdProceso : {
      required: true,
      type: Number,
      default: 0
    }, 
    nIdFormulario : {
      required: true,
      type: Number,
      default: 0
    },
    dataMap : {
      type: Object,
      default: () => {}
    }

  },  
  data () {
    return {
      nKeyFD: 0,
    }
  },
  mounted (){

  }, 
  computed : {
    // valido si tengo data en storoge para mostrarla en el fom
    cmp_oInitialFormFields (){
      const dataInStorage = this.getoVariablesGlobales_Filter(this.nIdProceso)
      if(Object.keys(dataInStorage).length > 0){
        return this.__prepararDataPreload(dataInStorage)
      }
      return {}
    },

    ...mapGetters('str_Procesos', ['getoVariablesGlobales_Filter'])
  }, 
  methods: {
    async procesar( formData, isValid, prepareData, oLocation) {

      if (!(await isValid())) {
        return;
      }
      // Filtramos el array para quitar elementos vacios (null, undefined) que no han sido llenados
      const formDataFiltrado = formData.filter(Boolean);

      const { aData, aFotos } = prepareData(formDataFiltrado);
      this.aFotos = aFotos;
      const dataCruda = aData;

      let bError = false

      Object.keys(this.dataMap).forEach( variable => {
        const aux_filter = dataCruda.filter( oRespuesta => {
          return oRespuesta?.Titulo === this.dataMap[variable].trim().replaceAll("_", " ") // quita blanco inicio fin y como pueden Venir con _ en vez de espacios se remplazan por espacios
        })
        // filtro solo debe regrear un valor sino hay un problema
        if (aux_filter.length === 1){
          // this.$store.dispatch("str_Procesos/push_oVariablesGlobales", { nIdProceso :this.nIdProceso, variable, valorTexto:aux_filter[0].TextoRespuesta, valorNumero: aux_filter[0].ValorRespuesta})
          this.$store.dispatch("str_Procesos/push_oVariablesGlobales", { nIdProceso :this.nIdProceso, variable, valor:this.__getValorStorage(aux_filter[0])})
        } else {
          bError = true
        }  
      })

      if(bError){
        this.$swal({
          timer: 3000,
          icon:  `error`,
          title: `Información Critica`,
          text: `Valide con el administrador hay campos no Mapeados`,
          showConfirmButton: true,
        })
        this.$store.dispatch("str_Procesos/clear_oVariablesGlobales_Proceso", { nIdProceso: this.nIdProceso } )

      } else {
        this.$swal({
          timer: 2000,
          icon:  `success`,
          title: `Información Registrada OK`,
          showConfirmButton: false,
        })
        this.$emit('bConfig')
        this.$emit('input', false)
      }  


    }, 
    __prepararDataPreload(dataInStorage){
      let dataPreparada = {}
      Object.keys(this.dataMap).forEach( registro =>{
        dataPreparada[this.dataMap[registro]] = dataInStorage[registro]
        this.nKeyFD++
      })
      return {config:{...dataPreparada}}
      
    },

    // esta funcion segun el tipo de campo prepara el valor a gaurdar.
    __getValorStorage(campo){

      switch (parseInt(campo.TipoPregunta)) {
      // Casos que usan ValorRespuesta (ej: numérico, selección, booleano)
      case 5: // CheckBox
      case 7: // EditText Numeros
      case 8: // EditText Texto
      case 9: // EditText Alfanumerico
        return campo.TextoRespuesta;
      
 
      case 1: // ToggleButton
      case 2: // Select
      case 3: // Foto
      case 4: // MultiSelect
      case 11: // RadioButton

        return [campo.ValorRespuesta, campo.TextoRespuesta];

      case 6: // Item
      case 10: // Calendarios
      case 12: // Firma
      case 13: // Informacion
      case 14: // Correo
      case 15: // Imagen  
      default:
      break;  
       

    }
       
    },

  }, // fin Methods
    
}
</script>

<style scoped>

</style>